import React from 'react';

const Modal = ({ children, onClose, isOpen, className }) => {

  const modalContent = (
    <div className="modal fixed inset-0 overflow-auto z-50 bg-black bg-opacity-50 flex items-center justify-center h-screen">
      <div className={`modal-content relative w-full mx-auto my-auto rounded-lg shadow-lg bg-white ${className || 'max-w-5xl'}`}>
        <button className="modal-close absolute top-3 right-1 z-50 px-4 py-2" onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
            </svg>
        </button>
        {children}
      </div>
    </div>
  );

  return (
    <>
      {isOpen && modalContent}
    </>
  );
};

export default Modal;